/* eslint-disable */
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import * as Yup from 'yup';
import { useNavigate, useParams } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Container, Stack, TextField, InputAdornment, IconButton } from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
import Divider from '@material-ui/core/Divider';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Page from '../../../Page';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import { AESEncryptionParam, AESDecryptionParam } from '../../../../helpers/AesEncrypt';
import services from '../Service';
import Button from '@material-ui/core/Button';
import { ToastContainer, toast } from 'react-toastify';
import MenuItem from '@material-ui/core/MenuItem';
import ImageUploader from 'react-images-upload';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardMedia from '@material-ui/core/CardMedia';
import Input from '@material-ui/core/Input';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import EditIcon from '@material-ui/icons/Edit';
import { stubTrue } from 'lodash';

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

export default function ProductDemandDetailsReport(props) {

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: true,
        submitButtonName: 'Update Order',
        pageheadername: 'Product Demand Details Report'
    });
    const [isTable, setIsTable] = useState(true);
    const [date1, setDate1] = useState(new Date());
    const [date2, setDate2] = useState(new Date());

    function createData(idNo, collectionCenter, crop, first, second, third, fourth, fifth, total) {
        return { idNo, collectionCenter, crop, first, second, third, fourth, fifth, total };
    }

    const rows = [
        createData('1', 'Boralanda','Capsicum', '1550', '', '2500', '', '250', '5250'),
        createData('2', 'Thanamalwila', 'Ash Planton', '500', '', '', '', '500', '1000'),
        createData('3', 'Haputhale','Capsicum', '1450', '', '100', '', '250', '1750')
    ];

    const [formData, setFormData] = useState({
        groupID: '1',
        operationEntityID: '1',        
        fromDateID: date1.toISOString().split('T')[0],
        toDateID: date2.toISOString().split('T')[0]
    });

    const productDemandDetailsReportSearchSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group required'),
        operationEntityID: Yup.number().min(1, 'Please Select Operation Entity').required('Operation Entity required'),
        // outeltID: Yup.number().min(1, 'Please Select Outlet').required('Outlet required'),
        fromDateID: Yup.date().min(1).min(1, 'Please Select From Date').required('From Date required'),
        toDateID: Yup.date().min(1).min(1, 'Please Select To Date').required('To Date required')
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: formData.operationEntityID,            
            fromDateID: formData.fromDateID,
            toDateID: formData.toDateID
        },

        validationSchema: productDemandDetailsReportSearchSchema,
        onSubmit: (values) => {
            if (pageProps.isEdit > 0) {
                // SubmitForm();
                setIsTable(true);
            } else {

            }
        }
    });
    const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;


    return (
        <Page title="Product Demand Details Report  |  Agri-Connect">
            <Container>
                <CommonPageHeader path="/dashboard" btname="Back" pageName={pageProps.pageheadername} leftButtonHidden={true} />
                <FormikProvider value={formik}>
                    <ToastContainer position="bottom-right" pauseOnHover />
                    <Form
                        autoComplete="off"
                        disabled={!(formik.isValid && formik.dirty)}
                        noValidate
                        onSubmit={handleSubmit}
                    >
                        <Stack spacing={2}>
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                <TextField
                                    select
                                    fullWidth
                                    size="small"
                                    label="Group *"
                                    value={formik.values.groupID}
                                    onChange={formik.handleChange}
                                    {...getFieldProps('groupID')}
                                    error={Boolean(touched.groupID && errors.groupID)}
                                    helperText={touched.groupID && errors.groupID}
                                >
                                    <MenuItem key={0} value={0}>
                                        {' '}
                                        Select Group
                                    </MenuItem>
                                    <MenuItem value={1}> Cargills</MenuItem>
                                </TextField>
                                <TextField
                                    select
                                    fullWidth
                                    size="small"
                                    label="Operation Entity *"
                                    value={formik.values.operationEntityID}
                                    onChange={formik.handleChange}
                                    {...getFieldProps('operationEntityID')}
                                    error={Boolean(touched.operationEntityID && errors.operationEntityID)}
                                    helperText={touched.operationEntityID && errors.operationEntityID}
                                >
                                    <MenuItem key={0} value={0}>
                                        {' '}
                                        Select Operation Entity
                                    </MenuItem>
                                    <MenuItem value={1}> Cargills</MenuItem>
                                </TextField>
                                <TextField
                                    fullWidth
                                    id="outlined-start-adornment"
                                    size="small"
                                    label="From Date *"
                                    type="Date"
                                    value={formik.values.fromDateID}
                                    onChange={formik.handleChange}
                                    {...getFieldProps('fromDateID')}
                                    error={Boolean(touched.fromDateID && errors.fromDateID)}
                                    helperText={touched.fromDateID && errors.fromDateID}
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start"></InputAdornment>
                                    }}
                                ></TextField>
                                <TextField
                                    fullWidth
                                    id="outlined-start-adornment"
                                    size="small"
                                    label="To Date *"
                                    type="Date"
                                    value={formik.values.toDateID}
                                    onChange={formik.handleChange}
                                    {...getFieldProps('toDateID')}
                                    error={Boolean(touched.toDateID && errors.toDateID)}
                                    helperText={touched.toDateID && errors.toDateID}
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start"></InputAdornment>
                                    }}
                                ></TextField>
                            </Stack>
                            <br />

                            <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                <Button type="submit" color="secondary" variant="outlined">
                                    Search
                                </Button>
                            </Stack>
                            <br />
                            <Divider variant="middle" />
                            <br />
                            {isTable ? (
                                <>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        <Card style={{ justifycontent: 'center', width: '85rem' }}>
                                            <TableContainer component={Paper}>
                                                <Table aria-label="simple table">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell align="center">Collection Center</TableCell>
                                                            <TableCell align="center">Crop</TableCell>
                                                            <TableCell align="center">1st</TableCell>
                                                            <TableCell align="center">2nd</TableCell>
                                                            <TableCell align="center">3rd</TableCell>
                                                            <TableCell align="center">4th</TableCell>
                                                            <TableCell align="center">5th</TableCell>
                                                            <TableCell align="center">Total</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {(rowsPerPage > 0
                                                            ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                            : rows).map((row) => (
                                                                <TableRow key={row.idNo}>
                                                                    <TableCell align="center">{row.collectionCenter}</TableCell>
                                                                    <TableCell align="center">{row.crop}</TableCell>
                                                                    <TableCell align="center">{row.first}</TableCell>
                                                                    <TableCell align="center">{row.second}</TableCell>
                                                                    <TableCell align="center">{row.third}</TableCell>
                                                                    <TableCell align="center">{row.fourth}</TableCell>
                                                                    <TableCell align="center">{row.fifth}</TableCell>
                                                                    <TableCell align="center">{row.total}</TableCell>
                                                                </TableRow>
                                                            ))}
                                                        {emptyRows > 0 && (
                                                            <TableRow style={{ height: 53 * emptyRows }}>
                                                                <TableCell colSpan={6} />
                                                            </TableRow>
                                                        )}
                                                    </TableBody>
                                                    <TableFooter>
                                                        <TableRow>
                                                            <TablePagination
                                                                rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                                                colSpan={8}
                                                                count={rows.length}
                                                                rowsPerPage={rowsPerPage}
                                                                page={page}
                                                                SelectProps={{
                                                                    inputProps: {
                                                                        'aria-label': 'rows per page',
                                                                    },
                                                                    native: true,
                                                                }}
                                                                onPageChange={handleChangePage}
                                                                onRowsPerPageChange={handleChangeRowsPerPage}
                                                                ActionsComponent={TablePaginationActions}
                                                            />
                                                        </TableRow>
                                                    </TableFooter>
                                                </Table>
                                            </TableContainer>
                                        </Card>
                                    </Stack>
                                    <Divider variant="middle" />
                                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                        <LoadingButton size="small" type='button'
                                            color="secondary" variant="outlined">
                                            PDF
                                        </LoadingButton>
                                        <LoadingButton size="small" type='button'
                                            color="secondary" variant="outlined">
                                            Excel
                                        </LoadingButton>
                                    </Stack>
                                </>
                            ) : null}
                        </Stack>
                    </Form>
                </FormikProvider>
            </Container>
        </Page>
    );
}